import { FormBody } from '../../Form'
import { Content } from '../../Modal'
import { useEpostFormContext } from '../Epost.hooks'
import { isEpostLoading } from '../Epost.utils'
import { EpostContactSupportEmailModal } from '../EpostContactSupportEmailModal'
import { EpostFormActions } from '../EpostFormActions'
import { EpostFormCalculatedTable } from '../EpostFormCalculatedTable'
import { EpostFormCalculateLoader } from '../EpostFormCalculateLoader'
import { EpostFormFields } from '../EpostFormFields'
import { EpostValidationErrors } from '../EpostValidationErrors'

import * as styles from './EpostFormContent.module.css'

function EpostFormContent() {
  const {
    calculateLoadingPercent,
    contentProps,
    handleCloseSupportModal,
    isCalculated,
    isCalculating,
    isOpenSupportModal,
    showContent = true,
    supportModalInitialValues,
    validationErrors,
    validationErrorsContentProps,
  } = useEpostFormContext()

  return (
    <FormBody Actions={null} className={styles.formBody}>
      <Content
        {...contentProps}
        contentWrapperClassName={styles.contentWrapper}
      >
        <EpostFormFields />
        <EpostFormActions />

        {showContent ? (
          <>
            {isCalculating ? (
              isEpostLoading(calculateLoadingPercent) ? (
                <EpostFormCalculateLoader />
              ) : null
            ) : (
              <>
                {isCalculated && validationErrors?.length === 0 ? (
                  <EpostFormCalculatedTable />
                ) : null}

                {isOpenSupportModal ? (
                  <EpostContactSupportEmailModal
                    initialValues={supportModalInitialValues}
                    onClose={handleCloseSupportModal}
                  />
                ) : null}
              </>
            )}
          </>
        ) : null}
      </Content>

      {!isCalculating && validationErrors?.length > 0 && showContent ? (
        <EpostValidationErrors {...validationErrorsContentProps} />
      ) : null}
    </FormBody>
  )
}

export default EpostFormContent
